import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'

import { Locale } from '@/i18n'

export const useLanguage = () => {
  const { i18n } = useTranslation()

  const selectLang = useCallback(
    (translations: Record<string, string>) => {
      return translations[i18n.language]
    },
    [i18n.language],
  )

  return {
    locale: i18n.language as Locale,
    selectLang,
  }
}
